import React, { useState } from "react";
import styled, { useTheme } from "styled-components";

export enum StatusInfoVariant {
  LOADING = "loading",
  ERROR = "error",
  OK = "ok",
}

type StatusInfoProps = {
  variant: StatusInfoVariant;
  text: string;
};

const StatusInfo = ({ variant, text }: StatusInfoProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const theme = useTheme();

  const getColors = () => {
    if (variant === StatusInfoVariant.ERROR) {
      return {
        backgroundColor: theme.colors.error400,
        textColor: theme.colors.error,
      };
    } else if (variant === StatusInfoVariant.OK) {
      return {
        backgroundColor: theme.colors.ok400,
        textColor: theme.colors.ok,
      };
    } else {
      return {
        backgroundColor: theme.colors.loading450,
        textColor: theme.colors.loading,
      };
    }
  };
  const colors = getColors();

  return isOpen ? (
    <StyledStatusInfo
      backgroundColor={colors.backgroundColor}
      textColor={colors.textColor}
      onClick={() => setIsOpen(false)}
    >
      {text}
    </StyledStatusInfo>
  ) : null;
};

const StyledStatusInfo = styled.div<{
  backgroundColor: string;
  textColor: string;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  position: fixed;
  bottom: 75px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 350px;
  text-align: center;
  padding: 15px;
  border-radius: ${({ theme }) => theme.radii.default};
  border: 1px solid ${({ textColor }) => textColor};
  text-shadow: 1px 1px black;
`;

export default StatusInfo;
